import { createSlice } from "@reduxjs/toolkit";
import axios from "../../services/authService";
import { API_ENDPOINTS } from '../../config/apiConfig';

export const deleteDevicesSlice = createSlice({
    name: "deleteDevices",
    initialState: {
        loading: false,
        response: {},
        error: null
    },
    reducers: {
        reset: (state) => {
            state.loading = false;
            state.response = {};
            state.error = null;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setResponse: (state, action) => {
            state.response = action.payload;
            state.loading = false;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        }
    }
});

export const {
    reset,
    setLoading,
    setResponse,
    setError
} = deleteDevicesSlice.actions;

/**
 * Delete a device from the database
 * @param {number} deviceId - The database ID of the device to delete
 */
export const deleteDeviceAsync = (deviceId) => async (dispatch) => {
    dispatch(reset());
    dispatch(setLoading(true));

    try {
        const url = `${API_ENDPOINTS.DELETE_DEVICE}?id=${deviceId}`;
        const response = await axios.delete(url);

        dispatch(setResponse({
            message: "Device deleted successfully",
            data: response.data
        }));

        return { success: true, data: response.data };

    } catch (err) {
        const errorMessage = err.response?.data?.message || err.message || "Failed to delete device";
        console.error("Error deleting device:", errorMessage);
        dispatch(setError(errorMessage));
        return { success: false, error: errorMessage };
    }
};

// Selectors
export const selectDeleteDeviceLoading = (state) => state.deleteDevices.loading;
export const selectDeleteDeviceResponse = (state) => state.deleteDevices.response;
export const selectDeleteDeviceError = (state) => state.deleteDevices.error;

export default deleteDevicesSlice.reducer;
